export enum FlowType {
  Join = 'join',
  Install = 'install',
  Host = 'host',
}

export enum Product {
  G2M = 'g2m',
  G2W = 'g2w',
  G2T = 'g2t',
}

export enum ThemeType {
  GoToMeetingTheme = 'GoToMeetingTheme',
  GoToTheme = 'GoToTheme',
}

export interface HandoverParams {
  error?: GoToError;
  flowType: FlowType;
  meetingId?: string;
  sessionTrackingId: string;
  meetingInfo: MeetingInfo;
  product: Product;
  firstName?: string;
  theme: GoToMeetingThemeTokens | GoToThemeTokens;
  webAppUrl?: string; // FIXME change to webAppJoinUrl also in CLS, consider downtime aka migration step
  ulfEnvConfig: EnvConfig;
  isDesktopEnforced?: boolean;
}

export interface MeetingInfo {
  build: string;
  nativeEPCompatibleVersions: string;
  sessionOptions: SessionOptions;
  authorizationCode?: string;
}

export interface SessionOptions {
  nativeEndpointDisabled: boolean;
  webViewerDefault: boolean;
}

export interface EnvConfig {
  webAppUrl: string; // FIXME change to webAppBaseUrl also in CLS, consider downtime aka migration step
  instantJoinBaseUrl?: string;
  jwtResolutionDomainBasePath: string;
  jwtOpenerPatchingBaseUrl: string;
  launcherStatusBaseUrl: string;
  telemetryServiceBaseUrl: string;
  engagementServiceBaseUrl: string;
}

interface BasicThemeToken {
  themeType: ThemeType;
}

interface GoToMeetingThemeTokens extends BasicThemeToken {
  themeType: ThemeType.GoToMeetingTheme;
}
interface GoToThemeTokens extends BasicThemeToken {
  themeType: ThemeType.GoToTheme;
}

export interface LaunchTokens {
  launcherServiceLaunchToken: string;
  openerLaunchToken: string;
  endpointToken: string;
}

interface GoToError {
  code: ErrorCode;
  message: string;
}

export enum ErrorCode {
  MissingProperty = 'MissingProperty',
  MissingUserAgent = 'MissingUserAgent',
  MalformedJsonWebToken = 'MalformedJsonWebToken',
  UnsupportedBrowser = 'UnsupportedBrowser',
  BreakoutUnsupportedBrowser = 'BreakoutUnsupportedBrowser',
  E2eeUnsupportedOperatingSystem = 'E2eeUnsupportedOperatingSystem',
  E2eeUnsupportedEapStatus = 'E2eeUnsupportedEapStatus',
}
